<template>
    <div>
        <template v-if="hasFeature('feat_maintenance_requests')">
            <maintenance-requests-list v-if="showIssuesList" :public-page-url="publicPageUrl" @toggle-list="toggleList()"></maintenance-requests-list>

            <maintenance-request-sharing-list v-else :public-page-url="publicPageUrl" @toggle-list="toggleList()"></maintenance-request-sharing-list>
        </template>

        <div v-else-if="!hasFeature('feat_maintenance_requests')" class="p-12">
            <div>
                <div class="row page-titles">
                    <div class="col-12 align-self-center">
                        <h3 class="text-center text-3xl font-medium">Online Problem Reporting</h3>
                        <h4 class="mt-5 text-center text-2xl font-medium text-blue-500">Available Now For <span class="font-bold">Enterprise</span> Clients</h4>
                        <h6 class=" mt-5 text-center text-base font-normal text-gray-700 max-w-1/2 mt-2 leading-normal">
                            Organize your maintenance by having tenants
                            <br>report problems directly to your RedRabbit profile
                        </h6>
                    </div>
                </div>

                <div class="mt-3 flex justify-around m-auto items-center">
                    <div class="p-5 bg-white rounded-lg shadow-lg max-w-2xl">
                        <img class="" src="/images/feat_maintenance.png"/>
                    </div>
                </div>

                <div class="text-center mt-6">
                    <h4 class="text-base font-medium"><a href="/settings#/tab-billing">Click here to upgrade now</a></h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MaintenanceRequestsDashboard",

    props: {
        publicPageUrl: {
            required: true,
            description: "Used for displaying the link at the top of the page"
        },
    },

    data () {
        return {
            showIssuesList: true,
        };
    },

    methods: {
        toggleList () {
            this.showIssuesList = !this.showIssuesList;
        },
    },
};
</script>
